
import { Component, Vue } from "vue-property-decorator";

@Component
export default class GroupeCle extends Vue {

  private headers1 = [
    {value: "name", text: "Nom"},
    {value: "status", text: "Statut"},
    {value: "actions", text: ""},
  ];
  private items1 = [
    {
      name: "PG-VERT",
      status: "Dans une boite à clé",
    },
    {
      name: "PG-BLEU",
      status: "Avec M Dupont",
    },
    {
      name: "PG-ROUGE",
      status: "Avec M Dupond",
    },
    {
      name: "PG-JAUNE",
      status: "Dans une boite à clé",
    },
  ];
  private headers2 = [
    {value: "name", text: "Nom"},
    {value: "status", text: "Statut"},
    {value: "actions", text: ""},
  ];
  private items2 = [
    {
      name: "Canon T04-134",
      status: "CANON-T04134-BLEU monté sur le lot T04-134",
    },
    {
      name: "Canon Secours 1",
      status: "",
    },
  ];
}
